const SIGNATURE_TTL_MS = 5 * 60 * 1000;

export function getMessengerSignatureStorageKey({ client, pipeline }) {
  return `lobster/${client}/${pipeline}/signature`;
}

export async function createMessengerSignature({ client, pipeline }) {
  const input = `${client}:${pipeline}:${Date.now()}:${getRandomToken()}`;

  if (window.crypto?.subtle && window.TextEncoder) {
    const digest = await window.crypto.subtle.digest(
      'SHA-256',
      new window.TextEncoder().encode(input)
    );

    return Array.from(new Uint8Array(digest))
      .map(byte => byte.toString(16).padStart(2, '0'))
      .join('');
  }

  return getFallbackHash(input);
}

export function saveMessengerSignature({ client, pipeline, signature }) {
  if (!client || !pipeline || !signature) {
    return;
  }

  try {
    sessionStorage.setItem(
      getMessengerSignatureStorageKey({ client, pipeline }),
      JSON.stringify({
        signature,
        expiresAt: Date.now() + SIGNATURE_TTL_MS
      })
    );
  } catch {
    // Ignore storage failures; the preview will fall back to normal caching.
  }
}

export function getMessengerSignature({ client, pipeline }) {
  if (!client || !pipeline) {
    return null;
  }

  const storageKey = getMessengerSignatureStorageKey({
    client,
    pipeline
  });

  try {
    const cachedValue = sessionStorage.getItem(storageKey);
    if (!cachedValue) {
      return null;
    }

    const parsedValue = JSON.parse(cachedValue);
    if (!parsedValue.signature || parsedValue.expiresAt <= Date.now()) {
      sessionStorage.removeItem(storageKey);
      return null;
    }

    return parsedValue.signature;
  } catch {
    sessionStorage.removeItem(storageKey);
    return null;
  }
}

function getRandomToken() {
  if (window.crypto?.getRandomValues) {
    const bytes = new Uint8Array(16);
    window.crypto.getRandomValues(bytes);
    return Array.from(bytes)
      .map(byte => byte.toString(16).padStart(2, '0'))
      .join('');
  }

  return Math.random().toString(36).slice(2);
}

function getFallbackHash(input) {
  let hash = 0;

  for (let i = 0; i < input.length; i += 1) {
    hash = Math.imul(31, hash) + input.charCodeAt(i);
    hash |= 0;
  }

  return Math.abs(hash).toString(16).padStart(8, '0');
}
